<template>
  <div>
    <strong class="fs_16" v-text="title" />
    <b-table
      class="mt-3 text-center bg-white score_competency_table"
      bordered
      responsive
      :fields="fields"
      :items="items"
    >
      <template #cell(score0)="data">
        <span v-html="renderIconCell(data.value)" />
      </template>
      <template #cell(score1)="data">
        <span v-html="renderIconCell(data.value)" />
      </template>
      <template #cell(score2)="data">
        <span v-html="renderIconCell(data.value)" />
      </template>
      <template #cell(score3)="data">
        <span v-html="renderIconCell(data.value)" />
      </template>
    </b-table>
    <b-row>
      <b-col cols="12" md="auto"
        ><i class="fas fa-circle mr-1 text-success" />خوب</b-col
      >
      <b-col cols="12" md="auto"
        ><i class="fas fa-circle mr-1 text-warning" />متوسط</b-col
      >
      <b-col cols="12" md="auto"
        ><i class="fas fa-circle mr-1 text-danger" />ضعیف</b-col
      >
    </b-row>
  </div>
</template>
<script>
import { pathOr } from "ramda";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    fields: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {
    pathOr,
    renderIconCell(value = null) {
      value = (value && value.trim()) || value;
      const data = {
        خوب: '<i class="fas fa-circle fa-2x text-success"/>',
        متوسط: '<i class="fas fa-circle fa-2x text-warning" />',
        ضعیف: '<i class="fas fa-circle fa-2x text-danger"/>',
      };
      return pathOr("", [value], data);
    },
  },
};
</script>

<style lang="scss">
.score_competency_table {
  tr {
    background-color: #fff !important;
  }
}
</style>